import { useCallback, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsUngatedForScpModuleInsertion } from 'case-study-lib/utils/auth';
import InpageModuleContext from 'ContentEditorUI/context/InpageModuleContext';
import useInpageModuleRefs from 'ContentEditorUI/hooks/useInpageModuleRefs';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-expect-error untyped
import { getEditSidebarActiveTab } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
// @ts-expect-error untyped
import StandardSidebarContainer from 'ContentEditorUI/components/StandardSidebarContainer';
// @ts-expect-error untyped
import SidebarContentContainer from 'ContentEditorUI/containers/SidebarContainer';
// @ts-expect-error untyped
import { getCurrentTab } from 'ContentEditorUI/redux/selectors/universalNavSelectors';
// @ts-expect-error untyped
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getActiveSidebarPanel, getSelectedField, getSidebarCategory
// @ts-expect-error untyped
} from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getSelectedRowOrColumn, getSelectedModuleInTree, getSelectedModuleName
// @ts-expect-error untyped
} from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { SIDEBAR_PANELS, LAYERS_SIDEBAR_WIDTH, EDIT_MODULE_SIDEBAR_WIDTH, PUSHY } from 'ContentEditorUI/lib/sidebar/constants';
import PatagoniaSidebarContentContainer from 'case-study-editor-ui/editor/containers/PatagoniaSidebarContentContainer';
import SidebarPanelContainer from './SidebarPanelContainer';
// @ts-expect-error untyped

// @ts-expect-error untyped
import PatagoniaAddPanel from 'ContentEditorUI/components/sidebar/PatagoniaAddPanel';
import { getDefaultAddPanelContentWidth } from 'ContentEditorUI/js/utils/sidebarUtil';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  editSidebarActiveTab: getEditSidebarActiveTab(state),
  selectedField: getSelectedField(state),
  selectedModuleInTree: getSelectedModuleInTree(state),
  selectedModuleName: getSelectedModuleName(state),
  selectedRowOrColumn: getSelectedRowOrColumn(state),
  isPatagonia: getIsUngatedForPatagonia(state),
  currentTab: getCurrentTab(state),
  selectedSidebarCategory: getSidebarCategory(state),
  categorizedSearchQuery: getSidebarSearchQuery(state)
});
const mapDispatchToProps = {};
function SidebarContainer(props) {
  const {
    currentTab,
    headerLabel,
    showDesignTab,
    showDeviceToggle,
    activePanel,
    isPatagonia,
    editSidebarActiveTab,
    selectedField,
    selectedModuleInTree,
    selectedModuleName,
    selectedRowOrColumn
  } = props;
  const categorizedSearchQuery = useSelector(getSidebarSearchQuery);
  const isUngatedForScpModuleInsertion = getIsUngatedForScpModuleInsertion();
  const inpageModuleRefs = useInpageModuleRefs();
  const renderSidebarPanelContainer = useCallback(() => {
    return /*#__PURE__*/_jsx(SidebarPanelContainer, {
      panelName: activePanel,
      selectedRowOrColumn: selectedRowOrColumn,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField
    });
  }, [activePanel, editSidebarActiveTab, selectedField, selectedModuleInTree, selectedModuleName, selectedRowOrColumn]);
  const renderSidebarContentContainer = useCallback(() => {
    return /*#__PURE__*/_jsx(SidebarContentContainer, {
      currentTab: currentTab,
      showDesignTab: showDesignTab,
      headerLabel: headerLabel,
      showDeviceToggle: showDeviceToggle,
      children: renderSidebarPanelContainer()
    });
  }, [currentTab, showDesignTab, headerLabel, renderSidebarPanelContainer, showDeviceToggle]);
  const sidebarConfig = useMemo(() => {
    const tooltipLabel = 'patagonia.sidebar.tooltipLabel';
    return [...(isUngatedForScpModuleInsertion ? [{
      type: 'panel',
      iconName: 'add',
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.add`
      }),
      panelName: SIDEBAR_PANELS.addWidget,
      content: /*#__PURE__*/_jsx(PatagoniaAddPanel, {}),
      contentWidth: getDefaultAddPanelContentWidth(PATAGONIA_ADD_PANEL_CATEGORIES.MODULES, Boolean(categorizedSearchQuery)),
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }] : []), {
      type: 'panel',
      iconName: 'siteTree',
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.pageContents,
      content: /*#__PURE__*/_jsx(PatagoniaSidebarContentContainer, {}),
      contentWidth: LAYERS_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'edit',
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.edit,
      content: renderSidebarContentContainer(),
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      hideItem: true,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }];
  }, [renderSidebarContentContainer, categorizedSearchQuery, isUngatedForScpModuleInsertion]);
  const sidebarConfigs = isPatagonia ? sidebarConfig : null;
  return /*#__PURE__*/_jsx(InpageModuleContext.Provider, {
    value: inpageModuleRefs,
    children: /*#__PURE__*/_jsx(StandardSidebarContainer, {
      showDesignTab: true,
      showDeviceToggle: true,
      sidebarOptions: sidebarConfigs,
      children: !isPatagonia && renderSidebarPanelContainer()
    })
  });
}
export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);